/* ==========================================================================
   SYNOVA — Favoris

   Sans compte client : la liste vit dans le stockage local du navigateur.
   C'est volontaire — demander une inscription pour enregistrer un article
   fait perdre la cliente qui vient d'une publicité.

   Conséquence assumée, à connaître : la liste est propre à un navigateur et
   à un appareil. Une synchronisation multi-appareils exigerait des comptes
   clients ou une application tierce.

   Les données produit ne sont jamais dupliquées : on ne stocke que les
   identifiants, et le tiroir récupère les informations fraîches auprès de
   Shopify (/products/<handle>.js) à l'ouverture. Prix, disponibilité et
   visuels restent donc toujours exacts.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'synova:wishlist';
  var MAX_ITEMS = 60;

  /* ======================================================================
     Stockage
     ====================================================================== */

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      }) : [];
    } catch (error) {
      // Navigation privée ou stockage plein : on dégrade sans casser la page.
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (error) {
      /* sans conséquence : la session reste utilisable */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var index = list.indexOf(handle);
    if (index === -1) {
      list.unshift(handle);
    } else {
      list.splice(index, 1);
    }
    write(list);
    sync();
    return index === -1;
  }

  function remove(handle) {
    var list = read().filter(function (h) {
      return h !== handle;
    });
    write(list);
    sync();
  }

  /* ======================================================================
     Synchronisation de l'interface
     ====================================================================== */

  function sync() {
    var list = read();

    // Boutons cœur : état actif
    document.querySelectorAll('[data-syn-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-syn-wishlist-toggle');
      var active = list.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active ? 'Retirer des favoris' : 'Ajouter aux favoris'
      );
      var label = button.querySelector('[data-syn-wishlist-label]');
      if (label) label.textContent = active ? 'Dans vos favoris' : 'Ajouter aux favoris';
    });

    // Compteur du header : masqué tant que la liste est vide
    document.querySelectorAll('[data-syn-wishlist-open]').forEach(function (trigger) {
      trigger.hidden = list.length === 0;
    });
    document.querySelectorAll('[data-syn-wishlist-count]').forEach(function (el) {
      el.textContent = String(list.length);
    });
  }

  /* ======================================================================
     Tiroir
     ====================================================================== */

  var drawer = null;

  /**
   * Formatage monétaire. La devise et la langue viennent de la boutique
   * (attributs posés par le tiroir), jamais d'une valeur codée en dur :
   * une boutique en livres ou en dollars s'affiche correctement.
   */
  function money(cents) {
    var currency =
      (drawer && drawer.getAttribute('data-syn-currency')) ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'EUR';
    var locale =
      (drawer && drawer.getAttribute('data-syn-locale')) ||
      document.documentElement.lang ||
      'fr';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  /**
   * Vignette redimensionnée par le CDN Shopify.
   * On utilise le paramètre `width` (format actuel) plutôt que le suffixe
   * `_400x` hérité, en préservant les paramètres déjà présents dans l'URL.
   */
  function thumbnail(url, width) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function cardMarkup(product) {
    var available = product.available;
    var image =
      product.featured_image ||
      (product.images && product.images.length ? product.images[0] : null);

    var media = image
      ? '<img src="' + thumbnail(image, 400) +
        '" alt="" loading="lazy" decoding="async">'
      : '<div class="syn-placeholder syn-placeholder--card">' +
        '<span class="syn-placeholder__mark" aria-hidden="true">SYNOVA</span>' +
        '<span class="syn-placeholder__label">Photo à ajouter</span></div>';

    return (
      '<li class="syn-wl-item" data-syn-wl-item="' + product.handle + '">' +
      '<a class="syn-wl-item__media" href="/products/' + product.handle + '">' + media + '</a>' +
      '<div class="syn-wl-item__body">' +
      '<a class="syn-wl-item__title" href="/products/' + product.handle + '">' +
      product.title +
      '</a>' +
      '<p class="syn-wl-item__price">' + money(product.price) + '</p>' +
      (available
        ? ''
        : '<p class="syn-wl-item__status">Épuisé</p>') +
      '<div class="syn-wl-item__actions">' +
      '<a class="syn-btn syn-btn--sm" href="/products/' + product.handle + '">Voir</a>' +
      '<button type="button" class="syn-wl-item__remove" data-syn-wl-remove="' +
      product.handle +
      '" aria-label="Retirer ' + product.title + ' des favoris">Retirer</button>' +
      '</div>' +
      '</div>' +
      '</li>'
    );
  }

  function renderEmpty(body) {
    body.innerHTML =
      '<div class="syn-wl-empty">' +
      '<span class="syn-wl-empty__icon" aria-hidden="true">♡</span>' +
      '<p class="syn-wl-empty__title">Aucun favori pour l’instant</p>' +
      '<p class="syn-wl-empty__text">Touchez le cœur sur un article pour le retrouver ici.</p>' +
      '</div>';
  }

  function load() {
    if (!drawer) return;
    var body = drawer.querySelector('[data-syn-wishlist-body]');
    if (!body) return;

    var handles = read();
    if (!handles.length) {
      renderEmpty(body);
      return;
    }

    body.innerHTML = '<p class="syn-wl-loading">Chargement…</p>';

    /*
     * On interroge Shopify pour chaque article. Les requêtes partent en
     * parallèle mais l'ordre d'affichage suit celui de la liste.
     * Un article supprimé du catalogue renvoie une erreur : on le retire
     * silencieusement plutôt que d'afficher une carte morte.
     */
    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var valid = products.filter(Boolean);

      // Purge des articles devenus introuvables
      var validHandles = valid.map(function (p) {
        return p.handle;
      });
      if (validHandles.length !== handles.length) {
        write(handles.filter(function (h) {
          return validHandles.indexOf(h) !== -1;
        }));
        sync();
      }

      if (!valid.length) {
        renderEmpty(body);
        return;
      }

      body.innerHTML =
        '<ul class="syn-wl-list" role="list">' +
        valid.map(cardMarkup).join('') +
        '</ul>';
    });
  }

  function open() {
    if (!drawer) return;
    load();
    if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    } else {
      drawer.setAttribute('open', '');
    }
    document.documentElement.setAttribute('scroll-lock', '');
  }

  function close() {
    if (!drawer || !drawer.open) return;
    if (typeof drawer.close === 'function') drawer.close();
  }

  /* ======================================================================
     Évènements
     ====================================================================== */

  function init() {
    drawer = document.querySelector('[data-syn-wishlist-drawer]');

    document.addEventListener('click', function (event) {
      // Basculer un favori
      var toggleBtn = event.target.closest('[data-syn-wishlist-toggle]');
      if (toggleBtn) {
        event.preventDefault();
        event.stopPropagation();
        var handle = toggleBtn.getAttribute('data-syn-wishlist-toggle');
        if (!handle) return;
        var added = toggle(handle);
        toggleBtn.classList.toggle('is-just-added', added);
        if (added) {
          window.setTimeout(function () {
            toggleBtn.classList.remove('is-just-added');
          }, 700);
        }
        return;
      }

      // Ouvrir le tiroir
      if (event.target.closest('[data-syn-wishlist-open]')) {
        event.preventDefault();
        open();
        return;
      }

      // Fermer
      if (event.target.closest('[data-syn-wishlist-close]')) {
        close();
        return;
      }

      // Retirer un article depuis le tiroir
      var removeBtn = event.target.closest('[data-syn-wl-remove]');
      if (removeBtn) {
        var target = removeBtn.getAttribute('data-syn-wl-remove');
        var row = document.querySelector('[data-syn-wl-item="' + target + '"]');
        remove(target);
        if (row) {
          row.classList.add('is-leaving');
          window.setTimeout(function () {
            row.remove();
            if (!read().length) {
              var body = drawer && drawer.querySelector('[data-syn-wishlist-body]');
              if (body) renderEmpty(body);
            }
          }, 220);
        }
      }
    });

    if (drawer) {
      drawer.addEventListener('close', function () {
        if (!document.querySelector('dialog.syn-modal[open]')) {
          document.documentElement.removeAttribute('scroll-lock');
        }
      });

      // Clic sur le fond
      drawer.addEventListener('click', function (event) {
        if (event.target !== drawer) return;
        var box = drawer.getBoundingClientRect();
        var inside =
          event.clientX >= box.left &&
          event.clientX <= box.right &&
          event.clientY >= box.top &&
          event.clientY <= box.bottom;
        if (!inside) close();
      });
    }

    // Un autre onglet a modifié la liste
    window.addEventListener('storage', function (event) {
      if (event.key === STORAGE_KEY) sync();
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', sync);

  // Exposé pour d'éventuels usages ponctuels depuis un bloc de code Liquid.
  window.SynovaWishlist = { read: read, has: has, toggle: toggle, remove: remove, sync: sync };
})();
